import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { queries } from '../../common/api/queryKeys/queries';
import { useAbly } from '../../common/hooks/useAbly';

import { useMarkRfqRead } from './useMarkRfqRead';

export const useRfqDetails = (id: string) => {
    const queryClient = useQueryClient();
    const { subscribe, unsubscribe } = useAbly();
    const query = useQuery(queries.requestsForQuotes.detail(id));

    const rfq = query.data;
    const rfqId = rfq?.id;
    const supplierId = rfq?.supplierId;

    // Mark RFQ as read when loaded
    useMarkRfqRead({
        rfqId: id,
        supplierId,
        supplierRead: rfq?.supplierRead,
    });

    useEffect(() => {
        if (!rfqId || !supplierId) {
            return;
        }

        const topic = `suppliers:${supplierId}:request-for-quotes:${rfqId}`;

        subscribe(topic, (message: { name: string }) => {
            if (message.name === 'UPDATED') {
                queryClient.invalidateQueries({ queryKey: queries.requestsForQuotes.detail(id).queryKey });
            }
        });

        return () => {
            unsubscribe(topic);
        };
    }, [id, queryClient, rfqId, supplierId, subscribe, unsubscribe]);

    return query;
};
